class Event {
  constructor() {
    this.lastApplication = null
  }
  _init = async () => {
    return true
  }

  resolve = async (event, data = null) => {
    let _event = {}
    if (!event.type) {
      event = {
        type: event,
        detail: data
      }
    }

    if (event.cookie) _$.vue.$emit(`event${event.cookie}`, event)
    if (event.cookie > -1) return false

    /* Platform-specific Event */
    if (event.type === "ApplicationControl" && event.detail.ActiveApplications) {
      const activeApp = event.detail.ActiveApplications.filter(rec => !rec.ApplicationName.includes("VolumeControl")).shift()

      if (activeApp.ApplicationName === "") activeApp.ApplicationName = "CustomDashboard"
      if (activeApp.ApplicationName === this.lastApplication) return false

      this.lastApplication = activeApp.ApplicationName

      if (activeApp.ApplicationName === "CustomDashboard") await __._app.launch("CustomDashboard").then(() => (_event.name = "applicationFocusing"))
      else await __._app.close("CustomDashboard").then(() => (_event.name = "applicationUnfocused"))
      await _$.sleep(1000)
    } else if (event.type === "Source") {
      _event.name = "source"
      _event.data = event.detail.TunedSource
    } else if (event.type === "ChannelSelection") {
      let state = event.detail.ChannelStatusDetails

      if (state.ChannelSelectionStatus === "Successful" && state.ChannelPlayingStatus === "Playing") _event.name = "mediaPlaying"
      else if (state.ChannelSelectionStatus === "Failure") _event.name = "mediaError"
      else if (state.ChannelSelectionStatus === "Stopped") _event.name = "mediaStopped"
      else return false
    } else if (["playing", "ended", "stopped", "pause", "error"].indexOf(event.type) >= 0) {
      let tempName
      switch (event.type) {
        case "playing":
          tempName = "mediaPlaying"
          break
        case "ended":
          tempName = "mediaEnded"
          break
        case "pause":
          tempName = "mediaPaused"
          break
        case "stopped":
          tempName = "mediaStopped"
          break
        default:
          tempName = "mediaError"
          break
      }
      _event.name = tempName
    } else if (event.type === "PowerState") {
      if (event.detail.Transition === "Yes") return false
      _event.name = "power"
      _event.data = event.detail.CurrentPowerState.toLowerCase()
      if (_event.data === "on") await _$.sleep(2000)
    }
    return _event
  }
  _setVideoSize = async () => {
    const { width, height, x, y, index } = __.common.tvWindowMetrics

    return __._common.setTvWindowSize({ width, height, x, y, index }, true).catch(err => _$.error(err))
  }
}

export default Event
